import React from 'react'
import EchartsCom from '@/components/echarts'
const EchartsComMemo = props => {
  return (
    <>
      <EchartsCom echartProps={props.echartProps} styleProps={{ ...props.styleProps }} />
    </>
  )
}
const areEqual = (prevProps, nextProps) => {
  /*
  返回true则不更新，返回false则更新。
  例如，比较深层结构：
  */
  return prevProps.rederFlag === nextProps.rederFlag
}
export default React.memo(EchartsComMemo, areEqual)
